import { useState } from "react";

export const PinModal = ({ title, subtitle, onSubmit, onClose, error: extError }) => {
  const [pin, setPin] = useState("");
  const [busy, setBusy] = useState(false);
  const go = async () => {
    if (pin.length < 4 || busy) return;
    setBusy(true);
    await onSubmit(pin);
    setBusy(false);
    setPin("");
  };
  return (
    <div data-testid="pin-modal" className="fixed inset-0 z-[80] bg-black/85 flex items-center justify-center p-4" onClick={onClose}>
      <div onClick={(e) => e.stopPropagation()} className="w-full max-w-xs rounded-3xl bg-[#141419] border border-[#D4AF37]/40 p-5 text-center">
        <p className="text-lg font-black tracking-wide">{title || "Enter your PIN"}</p>
        {subtitle && <p className="text-white/45 text-sm mt-1">{subtitle}</p>}
        <div className="flex justify-center gap-3 mt-4 h-4">
          {[0, 1, 2, 3, 4, 5].map((i) => (
            <span key={i} className={`w-3.5 h-3.5 rounded-full ${i < pin.length ? "bg-[#D4AF37]" : "bg-white/15"} ${i > 3 && i >= pin.length ? "opacity-30" : ""}`} />
          ))}
        </div>
        {extError && <p data-testid="pin-modal-error" className="text-[#FF5A4E] text-sm font-bold mt-2">{extError}</p>}
        <div className="grid grid-cols-3 gap-2.5 mt-4">
          {["1", "2", "3", "4", "5", "6", "7", "8", "9", "⌫", "0", "GO"].map((k) => (
            <button key={k} data-testid={`pin-key-${k === "⌫" ? "del" : k}`}
              onClick={() => (k === "⌫" ? setPin(pin.slice(0, -1)) : k === "GO" ? go() : setPin((pin + k).slice(0, 6)))}
              disabled={busy || (k === "GO" && pin.length < 4)}
              className={`h-14 rounded-xl text-xl font-black num ${
                k === "GO" ? "bg-[#D4AF37] text-black text-base tracking-widest disabled:opacity-40" : "s-card text-white"}`}>
              {k}
            </button>
          ))}
        </div>
        <button data-testid="pin-modal-cancel" onClick={onClose} className="mt-3 text-white/50 font-black text-sm tracking-widest py-2 w-full">CANCEL</button>
      </div>
    </div>
  );
};

export const usePinPrompt = () => {
  const [req, setReq] = useState(null);
  const ask = (title, subtitle) => new Promise((resolve) => setReq({ title, subtitle, resolve }));
  const el = req ? (
    <PinModal title={req.title} subtitle={req.subtitle}
      onSubmit={(pin) => { const r = req.resolve; setReq(null); r(pin); }}
      onClose={() => { const r = req.resolve; setReq(null); r(null); }} />
  ) : null;
  return [ask, el];
};
